export default __webpack_public_path__ + "static/media/editCompanyPlaceholder.7a327acb.svg";